module.exports = __webpack_public_path__ + "img/invitation_iamge_functions@2x.100e4dac.png";